import { createIcon } from "@chakra-ui/react";

export const UserGroup = createIcon({
  displayName: "UserGroup",
  viewBox: "0 0 24 24",
  d: "M5.4 7.8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm13.8 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM0 13.001c0 .439.36.799.799.799h8.029a4.789 4.789 0 0 1-1.624-3.6c0-.285.026-.563.071-.836A3.965 3.965 0 0 0 5.602 9h-1.6A4.003 4.003 0 0 0 0 13.001zm15.199.799H23.2a.8.8 0 0 0 .799-.799A4.003 4.003 0 0 0 19.999 9H18.4c-.596 0-1.162.131-1.672.364.049.27.071.551.071.836 0 1.433-.63 2.719-1.624 3.6h.027-.004zM12 8.4a1.8 1.8 0 1 1 0 3.6 1.8 1.8 0 0 1 0-3.6zm0 5.4a3.6 3.6 0 1 0 0-7.2 3.6 3.6 0 0 0 0 7.2zm-2.201 3H14.2a3.196 3.196 0 0 1 3.098 2.4H6.7A3.203 3.203 0 0 1 9.8 16.8zm0-1.8A5 5 0 0 0 4.8 19.999C4.8 20.55 5.246 21 5.801 21H18.2c.551 0 1.001-.446 1.001-1.001A5 5 0 0 0 14.201 15H9.8z",
  defaultProps: {
    "aria-label": "Three human, head and torso, symbols"
  }
});

export default UserGroup;
